import { type FC } from 'react'
import { type ResultDisplayProps } from '../../common'
import { useZocksQuota } from '../../../../../../../components/ScopedBlock/hooks'
import { SchedulingFutureMeetings } from './SchedulingFutureMeetings'
import { FutureMeetings } from './FutureMeetings'

export const FutureMeetingsDisplay: FC<ResultDisplayProps> = (props) => {
  const { hasQuota, quotaSuccess, isFetching } = useZocksQuota({ refetchQuota: false, pollingInterval: 0 })

  if (!quotaSuccess && isFetching) {
    return null
  }

  return hasQuota('scheduling.enabled.value') ? <SchedulingFutureMeetings {...props} /> : <FutureMeetings {...props} />
}
